export const brandInfo = {
  name: 'Shabi Media',
  since: '1988',
  phone: '+91 81222 52218',
  phoneLink: 'tel:+918122252218',
  email: 'hello@shabimedia.com',
  whatsappLink:
    'https://wa.me/918122252218?text=Hi%20Shabi%20Media%2C%20I%20would%20like%20to%20book%20a%20shoot.',
  logoImage:
    'https://storage.helloreaddy.io/project_files/8a6f075b-1abd-4055-a8ca-41b73a65bb44/fbc06365-520e-4836-b359-5134305d6d7a_compressed_logo.webp',
  coverImage:
    'https://storage.helloreaddy.io/project_files/8a6f075b-1abd-4055-a8ca-41b73a65bb44/8b0b2c4b-5051-4319-99ae-90d0f9c1fa2d_compressed_FB-Page-cover.webp',
}

export const navLinks = [
  { key: 'home', to: '/' },
  { key: 'about', to: '/about' },
  { key: 'services', to: '/services' },
  { key: 'wedding', to: '/wedding' },
  { key: 'printing', to: '/printing' },
  { key: 'gallery', to: '/gallery' },
  { key: 'contact', to: '/contact' },
]

export const footerExploreLinks = [
  { key: 'home', to: '/' },
  { key: 'about', to: '/about' },
  { key: 'services', to: '/services' },
  { key: 'wedding', to: '/wedding' },
  { key: 'weddingStories', to: '/wedding-stories' },
  { key: 'printing', to: '/printing' },
  { key: 'gallery', to: '/gallery' },
  { key: 'contact', to: '/contact' },
]

export const socialLinks = [
  {
    id: 'so1',
    icon: 'ri-whatsapp-line',
    label: 'WhatsApp',
    href: 'https://wa.me/918122252218?text=Hi%20Shabi%20Media%2C%20I%20would%20like%20to%20book%20a%20shoot.',
  },
  { id: 'so2', icon: 'ri-instagram-line', label: 'Instagram', href: 'https://www.instagram.com/' },
  { id: 'so3', icon: 'ri-facebook-circle-line', label: 'Facebook', href: 'https://www.facebook.com/' },
  { id: 'so4', icon: 'ri-youtube-line', label: 'YouTube', href: 'https://www.youtube.com/' },
]

export const stats = [
  { id: 's1', value: '36+', icon: 'ri-award-line' },
  { id: 's2', value: '12K+', icon: 'ri-heart-3-line' },
  { id: 's3', value: '48K+', icon: 'ri-emotion-happy-line' },
  { id: 's4', value: '2', icon: 'ri-map-pin-2-line' },
]

export const whyUsPoints = [
  { id: 'w1', icon: 'ri-time-line' },
  { id: 'w2', icon: 'ri-team-line' },
  { id: 'w3', icon: 'ri-magic-line' },
  { id: 'w4', icon: 'ri-printer-line' },
  { id: 'w5', icon: 'ri-shield-check-line' },
  { id: 'w6', icon: 'ri-price-tag-3-line' },
]

export const processSteps = [
  { id: 'p1', step: '01' },
  { id: 'p2', step: '02' },
  { id: 'p3', step: '03' },
  { id: 'p4', step: '04' },
]

export const testimonials = [
  { id: 't1', rating: 5 },
  { id: 't2', rating: 5 },
  { id: 't3', rating: 5 },
  { id: 't4', rating: 5 },
]